define('views/modules/questionnaire/responses/answers/answer-info-section',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/modules/questionnaire/responses/answers/answer-comment-form',
    // templates
    'text!templates/modules/questionnaire/responses/answers/answer-info-section.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VAnswerCommentForm,
    // templates
    TAnswerInfoSection
) {

    var VAnswerInfoSection = Backbone.View.extend({
        template: TAnswerInfoSection,

        regions: {
            answer: ".question-answer",
        },

        initialize: function(opt) {
            this.options = opt || {};
            this.answer = this.options.answer;
        },

        render: function() {

            // Render Template HTML with Mustache
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext(_.extend({},
                this.options,
                this.answer.toJSON()
            ))));

            this.generateZones();

            return this;
        },

    });

    return VAnswerInfoSection;
});

